import React from 'react'
// styles
import './theSoldiers_styles.css';
// data
import { plaqueData } from "../data_withLatLong";
// comps
import HouseMap, { daltonPosition } from '../components/HouseMap';
import SoldierList from "../components/SoldierList";
import SearchPanel from "../components/SearchPanel";
// import ErrorsWarning from "../components/ErrorsWarning";

class TheSoldiers extends React.Component {

    constructor(props) {
        super(props);

        this.state = { mapCenter: [daltonPosition.lat, daltonPosition.lng], filteredSoldiers: plaqueData, searchText: '', currentDayOfWar: 1, isPlaying: false };

        this.selectMarker = this.selectMarker.bind(this);
        this.deselectMarker = this.deselectMarker.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
        this.onSearchClose = this.onSearchClose.bind(this);
        this.onDayChange = this.onDayChange.bind(this);
        this.onTimelineClose = this.onTimelineClose.bind(this);
    }

    /*componentDidMount(){
        this.onSearchChange('Garfield')
    }*/

    onSearchChange(newText) {
        let searchResults = [];

        plaqueData.map(data => {
            const { firstname, middlenames, lastname, house, street, town, regiment } = data;
            const searchTxt = `${firstname} ${middlenames} ${lastname} ${house} ${street} ${town} ${regiment}`;

            if (searchTxt.toLowerCase().indexOf(newText.toLowerCase()) > -1) {
                searchResults.push(data);
            }

            return null;
        });

        this.setState({ searchText: newText, filteredSoldiers: searchResults })
    }

    selectMarker(selectedSoldierId) {

        const currentSoldierData = plaqueData.find(soldier => soldier.uid === selectedSoldierId);
        const { firstname, middlenames, lastname } = currentSoldierData;

        const soldierName = `${firstname ? firstname : ''} ${middlenames ? middlenames : ''} ${lastname ? lastname : ''}`;

        // const mapCenter = [currentSoldierData.lat, currentSoldierData.lng];

        this.setState({ filteredSoldiers: [currentSoldierData], searchText: soldierName });
    }

    deselectMarker() {
        this.setState({ filteredSoldiers: plaqueData, searchText: `` });
    }

    onSearchClose() {
        this.onSearchChange('');
    }

    onTimelineClose() {
        this.setState({ currentDayOfWar: 1, isPlaying: false });
    }

    onDayChange(currentDayOfWar) {
        this.setState({ currentDayOfWar })
    }

    render() {
        const { currentDayOfWar, isPlaying, filteredSoldiers, searchText, mapCenter } = this.state;

        let orderedByDateDied = filteredSoldiers.sort((a, b) => {
            if(a.lastname < b.lastname) return -1;
            if(a.lastname > b.lastname) return 1;
            return 0;

            /*if(!a && !b) return 0;
            if(!a) return 1;
            if(!b) return -1;

            return b.dateKilled - a.dateKilled;*/
        });

        let soldierList = isPlaying ? orderedByDateDied.filter(soldier => soldier.daysIntoWar <= currentDayOfWar) : orderedByDateDied;

        return (
            <div className={'theSoldiers'}>

                <div className={'theSoldiers--mapHolder'}>
                    <HouseMap data={soldierList}
                              mapCenter={mapCenter}
                              onMarkerDeselect={this.deselectMarker}
                              onMarkerSelect={this.selectMarker}/>
                </div>

                <SearchPanel searchText={searchText}
                             onSearchChange={this.onSearchChange}
                             onSearchClose={this.onSearchClose}/>

               {/*<ErrorsWarning/>*/}

                <SoldierList soldiers={soldierList}
                             currentDayOfWar={currentDayOfWar}
                             openBiog={false}/>

               {/*<ErrorsWarning/>*/}
            </div>
        )
    }
}

export default TheSoldiers;


// WEBPACK FOOTER //
// ./src/app/pages/TheSoldiers.js